import { useEffect } from "react";

const Help = () => {
  const settings = JSON.parse(localStorage.getItem("settings"));

  const getSrc = (lang) => {
    if (lang === "ja-JP") { // 일본어
      return "https://orchid-reading-347.notion.site/ebd//8af6f7a9d70946dc9aa2a4e623b192fa";
    } else if (lang === "ko-KR") { // 한국어
      return "https://orchid-reading-347.notion.site/ebd//209bafbc620c80918562f0651f9db3a5";
    } else if (lang === "zh-CN") { // 중국어(간체)
      return "https://orchid-reading-347.notion.site/ebd//240bafbc620c8092ad3cd1ddf97a4355";
    } else if (lang === "zh-TW") { // 중국어(번체)
      return "https://orchid-reading-347.notion.site/ebd//240bafbc620c8080abf1ee36afcff239"
    }
    // 기본 언어는 영어로 설정
    return "https://orchid-reading-347.notion.site/ebd//1c7bafbc620c807b8a87e6e6d3b1ff58";
  };

  useEffect(() => {
    function setFullViewportHeight() {
      document.documentElement.style.setProperty('--full-viewport-height', `${window.innerHeight}px`);
    }

    window.addEventListener('resize', setFullViewportHeight);
    setFullViewportHeight();

    document.documentElement.style.overflow = 'hidden';

    return () => {
      window.removeEventListener('resize', setFullViewportHeight);
    };
  }, []);

  return (
    <div style={{ margin: 0, padding: 0, height: '100%' }}>
      <iframe
        src={getSrc(settings?.lang || "en-US")}
        style={{ width: '100%', height: '100%', border: 'none' }}
        title="PlanNEL Online Manual"
        sandbox="allow-scripts allow-same-origin"
      ></iframe>
    </div>
  );
};

export default Help;
